import { CashBuildElementIdEnum } from '@shared/Enums/CashBuildElementIdEnum';

export function GetIdStoreHost(): string | null {
    const root = document.getElementById(CashBuildElementIdEnum.ROOT_CASHBUILD);
    return root?.getAttribute(CashBuildElementIdEnum.STORE_ID) || null;
}
